import { STATUS, STATUS_CLASSES, STATUS_DOT, UNKNOWN_STATUS_FALLBACK } from '../../lib/statusConfig';

// Title-case a raw status key for display when it isn't in the STATUS map
// (e.g. 'some_new_status' -> 'Some New Status').
function humanize(key) {
  return String(key || '')
    .split('_')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/**
 * Redesign StatusBadge — reads presentation from lib/statusConfig.
 * Unknown statuses render as a neutral grey chip with the raw key title-cased,
 * instead of a blank cell (should never happen for portal data: the DB CHECK
 * constraint guarantees the vocabulary — this is a display safety net).
 * @param {{status: string, className?: string}} props
 */
export default function StatusBadge({ status, className = '' }) {
  const cfg = STATUS[status];

  if (!cfg) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[StatusBadge] Unknown status:', status);
    }
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-chip px-2.5 py-1 text-[11px] font-semibold ${UNKNOWN_STATUS_FALLBACK.classes} ${className}`}>
        <span className={`h-1.5 w-1.5 rounded-full ${UNKNOWN_STATUS_FALLBACK.dot}`} />
        {humanize(status) || 'Unknown'}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-chip px-2.5 py-1 text-[11px] font-semibold ${STATUS_CLASSES[status]} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${STATUS_DOT[status]}`} />
      {cfg.label}
    </span>
  );
}
